<template>
  <div>
    <section>
      <div class="container">
        <h1 class="admin-page">Clientes</h1>
        <div class="pull-right" style="margin-top: 1em;">
          <router-link to="/clienteform" class="btn btn-fill">Nuevo</router-link>
        </div>
        <div class="row">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Razón social</th>
                <th>Fecha alta</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="cliente in clientes" :key="cliente._id">
                <td>{{cliente.razonSocial}}</td>
                <td>{{cliente.fechaAlta | formatFecha}}</td>
                <td>
                  <div class="button-group">
                    <ul class="table-actions smart-form">
                      <li>
                        <router-link :to="`/clienteform/edit/${cliente._id}`" class="btn btn-xs btn-ghost" type="button">
                          <i class="fa fa-actions fa-edit"></i>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import _ from 'lodash'
  import moment from 'moment'
  export default {
    data () {
      return {
        clientes: []
      }
    },
    filters: {
      formatFecha (value) {
        return moment(new Date(value)).format('DD/MM/YYYY HH:mm')
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/admin/clientes').then(({body}) => {
        me.clientes = _.sortBy(body.clientes, 'razonSocial')
      }, (err) => {
        console.error(err)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ListaClientes.vue?31d71f45